export default class StocksService {
	static $inject = ['$http'];

	constructor($http) {
		this.$http = $http;
	}

	async getGestionStocks(idSite, dateDebut, dateFin, elt1, elt2) {
		let filtres = {
			idSite: idSite,
			dateDebut: dateDebut,
			dateFin: dateFin,
			eltNiv1: elt1,
			eltNiv2: elt2
		};
		let res = await this.$http.get(`${__configuration.apiUrl}/massia/gestion-stocks`, {
			params: {
				filtres: JSON.stringify(filtres || {})
			}
		});

		return res.data;
	}

	async printGestionStock(idSite, dateDebut, dateFin, elt1, elt2) {
		let url = `${`${__configuration.apiUrl}/massia/gestion-stocks`}/print`;
		let filtres = {
			idSite: idSite,
			dateDebut: dateDebut,
			dateFin: dateFin,
			eltNiv1: elt1,
			eltNiv2: elt2
		};
		let res = await this.$http.get(url, {
			params: {
				filtres: JSON.stringify(filtres || {})
			},
			responseType: 'arraybuffer'
		});
		return res;
	}

	async getValorisationStocks(idGrpSite, idDebutPeriode, idFinPeriode, elt1, elt2, elt3, typeAnalyse) {
		let filtres = {
			idGrpSite: idGrpSite,
			idDebutPeriode: idDebutPeriode,
			idFinPeriode: idFinPeriode,
			eltNiv1: elt1,
			eltNiv2: elt2,
			eltNiv3: elt3,
			typeAnalyse: typeAnalyse ? typeAnalyse : 0
		};
		const valorisationUrl = `${__configuration.apiUrl}/massia/valorisation-stocks`;
		let res = await this.$http.get(valorisationUrl, {
			params: {
				filtres: JSON.stringify(filtres || {})
			}
		});

		return res.data;
	}

	async printValorisationStock(idGrpSite, idDebutPeriode, idFinPeriode, elt1, elt2, elt3, typeAnalyse) {
		let url = `${__configuration.apiUrl}/massia/valorisation-stocks/print`;
		let filtres = {
			idGrpSite: idGrpSite,
			idDebutPeriode: idDebutPeriode,
			idFinPeriode: idFinPeriode,
			eltNiv1: elt1,
			eltNiv2: elt2,
			eltNiv3: elt3,
			typeAnalyse: typeAnalyse ? typeAnalyse : 0
		};
		let res = await this.$http.get(url, {
			params: {
				filtres: JSON.stringify(filtres || {})
			},
			responseType: 'arraybuffer'
		});
		return res;
	}

	async setGestionStock(gestionStock) {
		const result = await this.$http.post(`${__configuration.apiUrl}/massia/gestion-stocks`, gestionStock);
		return result.data;
	}

	async getSites() {
		let url = `${__configuration.apiUrl}/massia/sites-commerciaux/headers`;
		let res = await this.$http.get(url);
		return res.data;
	}

	async getSitesCommerciaux(valeur) {
		const url = `${__configuration.apiUrl}/massia/sites-commerciaux/typeAhead/${valeur}`;
		const res = await this.$http.get(url);
		return res.data;
	}

	async getPeriodes(idSite) {
		const url = `${__configuration.apiUrl}/massia/valorisation-stocks/periodes/${idSite}`;
		const res = await this.$http.get(url);
		return res.data;
	}

	async getElementsNiv1(idGroupeSite = 0) {
		const url = `${__configuration.apiUrl}/massia/domaines/produitsstockes/elements-hierarchiques/stock1`;
		let res = await this.$http.get(url, {
			params: {
				idGroupeSite: idGroupeSite
			}
		});
		return res.data;
	}

	async getElementsNiv2(codeElt1) {
		const url = `${__configuration.apiUrl}/massia/domaines/produitsstockes/elements-hierarchiques/stock2/${codeElt1}`;
		let res = await this.$http.get(url);
		return res.data;
	}

	async getElementsNiv3(codeElt1, codeElt2) {
		const url = `${__configuration.apiUrl}/massia/domaines/produitsstockes/elements-hierarchiques/stock3/${codeElt1}/${codeElt2}`;
		let res = await this.$http.get(url);
		return res.data;
	}

	async getMotifs() {
		let url = `${__configuration.apiUrl}/massia/motifs-ajustement-stock/headers`;
		let res = await this.$http.get(url);
		return res.data;
	}

	async getMotifsDepreciation() {
		let url = `${__configuration.apiUrl}/massia/motifs-depreciation-stock/headers`;
		let res = await this.$http.get(url);
		return res.data;
	}

	async getAllProduits(idSite) {
		var url = `${__configuration.apiUrl}/massia/produits/produitsProducteur/${idSite}`;
		let res = await this.$http.get(url);
		return res.data;
	}

	async getProduitLies(idSite) {
		try {
			let filters = {
				siteCommercialId: idSite,
				entreeSortie: null
			};
			let url = `${__configuration.apiUrl}/massia/parametres/produits/lies`;

			let res = await this.$http.get(url, {
				params: {
					filters: filters || {}
				}
			});

			return res.data.produits;
		} catch (err) {
			throw err.data;
		}
	}

	async getZonesStockage(idSiteComm) {
		var url = `${__configuration.apiUrl}/massia/origines-destinations/header/${idSiteComm}`;
		let res = await this.$http.get(url);
		return res.data;
	}

	async getInventaires(filters, sorts, pagination) {
		let url = `${__configuration.apiUrl}/massia/inventaire-stocks`;
		let res = await this.$http.get(url, {
			params: {
				filters: JSON.stringify(filters || []),
				sorts: JSON.stringify(sorts || []),
				pagination: JSON.stringify(pagination || {})
			}
		});

		return res.data;
	}

	async getInventaireById(id) {
		let url = `${__configuration.apiUrl}/massia/inventaire-stocks/${id}`;
		let res = await this.$http.get(url);
		return res.data;
	}

	async getInventaireStockProduits(idGroupeSite, eltNiv1, idInventaire, date, isClotured) {
		let url = `${__configuration.apiUrl}/massia/inventaire-stocks/listeProduits`;

		let filtres = {
			idGroupeSite: idGroupeSite,
			eltNiv1: eltNiv1,
			idInventaire: idInventaire,
			date: date,
			isClotured: isClotured
		};
		let res = await this.$http.get(url, {
			params: {
				filtres: JSON.stringify(filtres || {})
			}
		});

		return res.data;
	}

	async printInventaireStock(idGroupeSite, eltNiv1, idInventaire, date) {
		let url = `${__configuration.apiUrl}/massia/inventaire-stocks/print`;
		let filtres = {
			idGroupeSite: idGroupeSite,
			eltNiv1: eltNiv1,
			idInventaire: idInventaire,
			date: date
		};
		let res = await this.$http.get(url, {
			params: {
				filtres: JSON.stringify(filtres || {})
			},
			responseType: 'arraybuffer'
		});
		return res;
	}

	async createInventaire(inventaire) {
		let url = `${__configuration.apiUrl}/massia/inventaire-stocks`;
		const result = await this.$http.post(url, inventaire);
		return result.data;
	}

	async updateInventaire(inventaire) {
		let url = `${__configuration.apiUrl}/massia/inventaire-stocks`;
		const result = await this.$http.put(url, inventaire);
		return result.data;
	}

	async createMouvement(inventaire) {
		let url = `${__configuration.apiUrl}/massia/inventaire-stocks/mouvements`;
		const result = await this.$http.post(url, inventaire);
		return result.data;
	}

	async sauveDepreciation(estDepreciationQuantite, idGroupeSite, idCloture, idProduit, idProducteur, idEmplacement, idMotif, quantite, prix) {
		let depreciation = {
			idGroupeSite: idGroupeSite,
			idCloture: idCloture,
			idProduit: idProduit,
			idSiteProducteur: idProducteur,
			idEmplacement: idEmplacement,
			idMotifDepreciation: idMotif,
			quantiteDepreciee: quantite,
			prixDeprecie: prix,
			estDepreciationQuantite: estDepreciationQuantite
		};
		let url = `${__configuration.apiUrl}/massia/valorisation-stocks`;
		const result = await this.$http.post(url, depreciation);
		return result.data;
	}

	async verifieDatesGestionStock(idSite, dateDebut, dateFin) {
		let filtres = {
			idSite: idSite,
			dateDebut: dateDebut,
			dateFin: dateFin
		};
		let url = `${`${__configuration.apiUrl}/massia/gestion-stocks`}/verifie-dates`;
		let res = await this.$http.get(url, {
			params: {
				filtres: JSON.stringify(filtres || {})
			}
		});

		return res.data;
	}

	async deleteInventaireById(id) {
		let url = `${__configuration.apiUrl}/massia/inventaire-stocks/${id}`;
		return this.$http.delete(url);
	}

	async getControls(idGrpSite) {
		const valorisationUrl = `${__configuration.apiUrl}/massia/valorisation-stocks/control/${idGrpSite}`;
		let res = await this.$http.get(valorisationUrl);

		return res.data;
	}

	async clotureMensuelle(grpSiteId, dateStockFinal, idPreCloture) {
		let data = {
			idGroupeSite: grpSiteId,
			dateStockFinal: dateStockFinal,
			idPreCloture: idPreCloture
		};
		let url = `${__configuration.apiUrl}/massia/valorisation-stocks/cloture-mois`;
		let res = await this.$http.put(url, data);
		return res.data;
	}

	async getSocietes() {
		let url = `${__configuration.apiUrl}/massia/societes-commerciales`;
		let res = await this.$http.get(url);
		return res.data;
	}

	async getRegroupementsSite(societeId) {
		const res = await this.$http.get(`${__configuration.apiUrl}/massia/regroupement-sites/societe/${societeId}`);
		return res.data;
	}

	async import({ file, inventaire }) {
		const formData = new FormData();
		formData.append('inventaire', JSON.stringify(inventaire));
		formData.append('file', file);
		const res = await this.$http.post(`${__configuration.apiUrl}/massia/inventaire-stocks/import`, formData, {
			transformRequest: angular.identity,
			headers: { 'Content-Type': undefined }
		});
		return res.data;
	}

	async decloturerMois(idGroupeSite, date) {
		let data = {
			date: date,
			idGroupeSite: idGroupeSite
		};
		let url = `${__configuration.apiUrl}/massia/mouvements-stock/decloture-mois`;
		let res = await this.$http.put(url, data);
		return res.data;
	}

	async getDerniereCloture(idGroupeSite) {
		let url = `${__configuration.apiUrl}/massia/mouvements-stock/derniere-cloture-jour-date-heure/${idGroupeSite}`;
		let res = await this.$http.get(url);
		return res.data;
	}

	async refreshMouvements(idGroupeSite) {
		let url = `${__configuration.apiUrl}/massia/gestion/gestion-rapport-activite/refresh-mouvements/${idGroupeSite}`;
		let res = await this.$http.get(url);
		return res.data;
	}
}
